<div class="card mb-0">
  <div class="flex justify-between mb-2">
    <div>
      <span class="block text-gray-700 dark:text-gray-100 font-medium mb-2"
        >Règles ayant échoué à l'évaluation (Total)</span
      >
      <div class="text-surface-900 dark:text-surface-0 font-bold text-xl">
        <span *ngIf="!loading">{{ failCount }}</span>
        <p-skeleton *ngIf="loading" width="4rem" height="2rem"></p-skeleton>
      </div>
    </div>
    <div
      class="flex items-center justify-center bg-orange-100/80 rounded-full"
      [ngStyle]="{ width: '2.5rem', height: '2.5rem' }"
    >
      <i class="pi pi-exclamation-triangle text-orange-500"></i>
    </div>
  </div>
  <div class="flex items-center gap-4">
    <div class="flex items-center gap-1">
      <i class="pi pi-check-circle text-orange-500 text-xs"></i>
      <span *ngIf="!loading" class="font-medium text-orange-500 text-sm">{{ workingCount }} fonctionnelles</span>
      <p-skeleton *ngIf="loading" width="6rem" height="1rem"></p-skeleton>
    </div>
    <div class="flex items-center gap-1">
      <i class="pi pi-clock text-orange-500 text-xs"></i>
      <span *ngIf="!loading" class="font-medium text-orange-500 text-sm">{{ staleCount }} en retard</span>
      <p-skeleton *ngIf="loading" width="6rem" height="1rem"></p-skeleton>
    </div>
  </div>
</div>
